import { useEffect, useState } from "react";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { getTicketDetails } from "../../services/shipperadviceservice";
import { setLoading } from "../../redux/appSlice";

const TicketDetail = ({ data }) => {
    const dispatch = useDispatch();
    const [detail, setDetail] = useState([]);

    useEffect(() => {
        const init = async () => {
            dispatch(setLoading({ data: true }));
            const rs = await getTicketDetails(data.cn);
            dispatch(setLoading({ data: false }));
            if (rs.sts == 0)
                setDetail(rs.data);
        }
        init();
    }, []);

    const thStyle = {
        fontWeight: 'bolder'
    }

    return <Fragment>
        {
            detail.length > 0 &&
            <tr>
                <td colSpan={14}>
                    <div style={{ background: 'rgba(0,0,0,0.04)', paddingTop: 15 }}>
                        <h3 style={{ textAlign: 'center', fontSize: 20 }}>Details</h3>
                        <table className="table table-bordered" style={{ fontSize: 13 }}>
                            <tbody>
                                <tr>
                                    <td style={thStyle}>Consignee</td>
                                    <td>{data.consignee}</td>
                                    <td style={thStyle}>Consignee Phone</td>
                                    <td>{data.consigneeContact}</td>
                                    <td style={thStyle}>Consignee Address</td>
                                    <td>{data.consigneeAddress}</td>
                                </tr>
                                <tr>
                                    <td style={thStyle}>COD Amount</td>
                                    <td>{data.codAmount}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="table-responsive">
                            <table className="table table-bordered" style={{ fontSize: 13 }}>
                                <thead>
                                    <tr>
                                        <td style={thStyle}>S.No</td>
                                        <td style={thStyle}>Status</td>
                                        <td style={thStyle}>Pending Ref No</td>
                                        <td style={thStyle}>Reason</td>
                                        <td style={thStyle}>Call Status</td>
                                        <td style={thStyle}>Call Time</td>
                                        <td style={thStyle}>Call Track</td>
                                        <td style={thStyle}>Comments</td>
                                        <td style={thStyle}>Consignee</td>
                                        <td style={thStyle}>Consignee Cell</td>
                                        <td style={thStyle}>Consignee Address</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        detail.map((z, index) =>
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{z.status}</td>
                                                <td>{z.ticketNo}</td>
                                                <td>{z.reason}</td>
                                                <td>{z.callStatus}</td>
                                                <td>{z.callTime}</td>
                                                <td>{z.callTrack}</td>
                                                <td>{z.comments}</td>
                                                <td>{z.consignee}</td>
                                                <td>{z.consigneeCell}</td>
                                                <td>{z.consigneeAddress}</td>
                                            </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </td>
            </tr>
        }
    </Fragment>
}

export default TicketDetail;